<template>
	<!--  side-over update-->
	<div :class="sideOverShow && type === 'update' ? 'side-over--active' : ''">
		<div
			v-if="sideOverShow && type === 'update'"
			class="
				fixed
				h-screen
				w-screen
				top-0
				left-0
				bg-black
				opacity-20
				z-30
			"
			@click="closeSideOver"
		></div>
		<UpdateGoalSkills
			:is-open="sideOverShow"
			:selected="[...allSelected]"
			:skills="skills"
			@close="closeSideOver"
			@updated="refetchData"
		/>
	</div>
	<!--  side-over change-->
	<div :class="sideOverShow && type === 'change' ? 'side-over--active' : ''">
		<div
			v-if="sideOverShow && type === 'change'"
			class="
				fixed
				h-screen
				w-screen
				top-0
				left-0
				bg-black
				opacity-20
				z-30
			"
			@click="closeSideOver"
		></div>
		<MoveToLibrary
			:is-lib="allFoldersSelected?.length"
			:is-open="sideOverShow"
			:selected="[...allSelected, ...allFoldersSelected]"
			:skills="skills"
			@close="closeSideOver"
			@updated="refetchData"
		/>
	</div>
	<DaModalFrame v-model:open="modalIsOpen">
		<DeleteGoalLibConfirm
			v-if="action === 'deleting' && goalDeleted && goalDeleted.root"
			:in-progress="inProgress"
			@close="closeModal"
			@submit="deleteLib(goalDeleted.id)"
		/>
		<DeleteConfirm
			v-if="action === 'deleting' && goalDeleted && !goalDeleted.root"
			:is-goal="goalDeleted.isGoal"
			@close="closeModal"
			@submit="deleteFolderItem(goalDeleted)"
		/>
		<CreateGoalFolder
			v-if="action === 'creating' && !goalDeleted"
			:error="error"
			:in-progress="inProgress"
			@close="modalIsOpen = false"
			@submit="createGoalFolder"
		/>
	</DaModalFrame>
	<DaModalFrame v-model:open="exitModalIsOpen">
		<ExitModal
			@close="exitModalIsOpen = false"
			@submit="
				exitModalIsOpen = false;
				$router.push({
					name: 'goal_reference',
				});
			"
		/>
	</DaModalFrame>
	<div>
		<div class="__report-lesson px-12 md-down:px-4 pb-30">
			<div
				class="
					pt-10
					__breadcrumbs
					text-sm text-neutral-500
					font-semibold
					flex-nowrap flex
					items-center
					justify-between
				"
			>
				<div class="flex items-center">
					<router-link :to="{ name: 'goal_reference' }">
						Thư Viện Tham khảo
					</router-link>
					<div class="__breadcrumbs__decorate">
						<DaIcon
							class="transform -rotate-90 h-3 w-3 mx-2"
							name="das--chevron-down"
						/>
					</div>
					<div>Chi Tiết Thư Viện</div>
				</div>
				<button
					class="
						button-p
						text-center
						w-fit
						btn--text
						text-neutral-500
						hover:text-neutral-600
					"
					type="button"
					@click="
						$router.push({
							name: 'goal_reference',
						})
					"
				>
					<svg
						class="mr-2 text-neutral-400"
						fill="none"
						height="16"
						viewBox="0 0 16 16"
						width="16"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z"
							fill="currentColor"
						/>
						<path
							d="M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z"
							fill="currentColor"
						/>
					</svg>
					Thoát
				</button>
			</div>
			<div
				class="
					mt-6
					__report-lesson__header
					flex flex-wrap
					gap-6
					md:flex-nowrap
					justify-between
					items-center
				"
			>
				<div>
					<div
						class="
							__record__title
							text-neutral-500
							font-semibold
							whitespace-nowrap
							flex flex-nowrap
							items-start
							text-4xl
							gap-4
						"
					>
						<svg
							class="cursor-pointer mt-1.5"
							fill="none"
							height="28"
							viewBox="0 0 28 28"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
							@click="
								$router.push({
									name: 'goal_reference',
								})
							"
						>
							<path
								d="M17.5 7L10.5 14L17.5 21"
								stroke="#94A3B8"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
							/>
						</svg>
						<div>
							<div class="flex items-center gap-6">
								<svg
									class="mb-1"
									fill="none"
									height="28"
									viewBox="0 0 28 28"
									width="28"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M25.4998 5.98259H11.021C10.7609 5.98259 10.5219 5.8514 10.3931 5.63913L9.104 3.51831C8.65802 2.78525 7.83103 2.33337 6.93503 2.33337H2.5C1.11897 2.33337 0 3.38904 0 4.69193V22.1415C0 23.4444 1.11897 24.5 2.5 24.5H25.5C26.881 24.5 28 23.4444 28 22.1415V8.34109C28 7.03906 26.881 5.98253 25.5 5.98253L25.4998 5.98259ZM4.09697 16.1387H6.65903C7.15613 16.1387 7.55903 16.5188 7.55903 16.9878C7.55903 17.4567 7.15613 17.8368 6.65903 17.8368H4.09697C3.59987 17.8368 3.19697 17.4567 3.19697 16.9878C3.19697 16.5188 3.59987 16.1387 4.09697 16.1387ZM10.437 21.1483H4.09697C3.59987 21.1483 3.19697 20.7682 3.19697 20.2992C3.19697 19.8303 3.59987 19.4501 4.09697 19.4501H10.4381C10.9352 19.4501 11.3381 19.8303 11.3381 20.2992C11.3379 20.768 10.935 21.1483 10.437 21.1483Z"
										fill="#94A3B8"
									/>
								</svg>
								<span>{{ goal.name }}</span>
							</div>
							<div
								v-if="isLucaEducation && goal.created_by_staff"
								class="
									uppercase
									text-green-500
									font-semibold
									text-sm
									mt-2
								"
							>
								tạo bởi
								<span class="text-blue-600">
									{{ goal.created_by_staff.name }}</span
								>
								<span>
									|
									{{
										goal?.is_completed
											? 'Công khai'
											: 'Bản nháp'
									}}
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="w-full flex items-center justify-end">
					<div
						class="search-input max-w-lg w-full"
						style="min-width: 160px"
					>
						<div class="input-group input--lg">
							<input
								v-model="searchQuery"
								class="bg-white input-with-icon"
								placeholder="Tìm theo tên mục tiêu"
								type="text"
								@keyup="searching"
								@keypress.enter="search"
							/>
							<div class="input-icon absolute top-1/2">
								<DaIcon
									class="h-4 w-4 text-neutral-400"
									name="das--search"
								/>
							</div>
						</div>
					</div>
					<Menu v-if="isLucaEducation" as="div" class="ml-3 relative">
						<div>
							<MenuButton
								class="
									rounded-full
									flex
									text-sm
									focus:outline-none
									focus:ring-2
									focus:ring-offset-2
									focus:ring-indigo-500
								"
							>
								<span class="sr-only">Open user menu</span>
								<svg
									fill="none"
									height="20"
									viewBox="0 0 20 20"
									width="20"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										clip-rule="evenodd"
										d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
										fill="#94A3B8"
										fill-rule="evenodd"
									/>
								</svg>
							</MenuButton>
						</div>
						<transition
							enter-active-class="transition ease-out duration-200"
							enter-from-class="transform opacity-0 scale-95"
							enter-to-class="transform opacity-100 scale-100"
							leave-active-class="transition ease-in duration-75"
							leave-from-class="transform opacity-100 scale-100"
							leave-to-class="transform opacity-0 scale-95"
						>
							<MenuItems
								class="
									origin-top-right
									absolute
									right-0
									mt-2
									w-60
									rounded-md
									py-1
									bg-white
									focus:outline-none
									z-10
									shadow-sm
									border border-yellow-100
								"
							>
								<MenuItem
									v-if="!rootGoals.length"
									v-slot="{ active }"
									@click="openCreateModal"
								>
									<div
										:class="active ? '' : ''"
										class="
											p-2
											px-4
											bg-white
											z-10
											text-gray-600
											hover:bg-neutral-50
											flex
											items-center
											gap-4
											cursor-pointer
										"
									>
										<svg
											fill="none"
											height="16"
											viewBox="0 0 16 16"
											width="16"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												clip-rule="evenodd"
												d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
												fill="#94A3B8"
												fill-rule="evenodd"
											/>
										</svg>
										<span>Tạo thư mục mới</span>
									</div>
								</MenuItem>
								<MenuItem
									v-slot="{ active }"
									@click="isEdit = !isEdit"
								>
									<div
										:class="active ? '' : ''"
										class="
											p-2
											px-4
											bg-white
											z-10
											text-gray-600
											hover:bg-neutral-50
											flex
											items-center
											gap-4
											cursor-pointer
										"
									>
										<svg
											v-if="!isEdit"
											fill="none"
											height="16"
											viewBox="0 0 16 16"
											width="16"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												clip-rule="evenodd"
												d="M12.4702 6.65087L13.7102 5.41084C13.8461 5.27498 13.914 5.20705 13.9667 5.14509C14.6009 4.39841 14.6009 3.30223 13.9667 2.55555C13.914 2.49359 13.8461 2.42566 13.7102 2.2898C13.5744 2.15394 13.5064 2.08601 13.4445 2.03338C12.6978 1.39915 11.6016 1.39915 10.855 2.03338C10.793 2.086 10.7251 2.15391 10.5893 2.2897L10.5892 2.28978L10.5892 2.2898L9.33099 3.54801C10.0747 4.84221 11.1583 5.91748 12.4702 6.65087ZM7.87633 5.00267L2.86273 10.0163C2.43767 10.4413 2.22514 10.6539 2.0854 10.915C1.94567 11.1761 1.88672 11.4708 1.76883 12.0602L1.37318 14.0385C1.30666 14.3711 1.27339 14.5374 1.368 14.632C1.46261 14.7266 1.62892 14.6934 1.96153 14.6269L3.9398 14.2312L3.93982 14.2312L3.93984 14.2312C4.52927 14.1133 4.82399 14.0544 5.08508 13.9146C5.34617 13.7749 5.55869 13.5624 5.98373 13.1373L5.98376 13.1373L5.98377 13.1373L11.0118 8.10931C9.75111 7.3111 8.68202 6.24922 7.87633 5.00267Z"
												fill="#94A3B8"
												fill-rule="evenodd"
											/>
										</svg>
										<svg
											v-else
											fill="none"
											height="16"
											viewBox="0 0 16 16"
											width="16"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M11.3333 2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V4.66667L11.3333 2ZM8 12.6667C6.89333 12.6667 6 11.7733 6 10.6667C6 9.56 6.89333 8.66667 8 8.66667C9.10667 8.66667 10 9.56 10 10.6667C10 11.7733 9.10667 12.6667 8 12.6667ZM10 6H3.33333V3.33333H10V6Z"
												fill="#94A3B8"
											/>
										</svg>
										<span>
											{{
												isEdit
													? 'Lưu chỉnh sửa'
													: 'Chỉnh sửa'
											}}</span
										>
									</div>
								</MenuItem>
								<MenuItem
									v-slot="{ active }"
									@click="openModalDeleted()"
								>
									<div
										:class="active ? '' : ''"
										class="
											p-2
											px-4
											bg-white
											z-10
											text-gray-600
											hover:bg-neutral-50
											flex
											items-center
											gap-4
											cursor-pointer
										"
									>
										<svg
											fill="none"
											height="16"
											viewBox="0 0 16 16"
											width="16"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												clip-rule="evenodd"
												d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
												fill="#94A3B8"
												fill-rule="evenodd"
											/>
										</svg>
										<span>Xoá thư viện</span>
									</div>
								</MenuItem>
							</MenuItems>
						</transition>
					</Menu>
				</div>
			</div>
			<div class="mt-4 text-gray-700">
				{{ goal.description }}
			</div>
			<div class="mt-6 flex justify-end gap-6">
				<button
					v-if="isLucaEducation"
					:disabled="!allSelected.length"
					class="
						button-p
						text-center
						whitespace-nowrap
						w-fit
						px-4
						btn--ghost
					"
					type="button"
					@click="openSideOver('update')"
				>
					<svg
						fill="none"
						height="16"
						viewBox="0 0 16 16"
						width="16"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							clip-rule="evenodd"
							d="M12.4705 6.65078L13.7105 5.41075C13.8463 5.27489 13.9143 5.20696 13.9669 5.14499C14.6011 4.39832 14.6011 3.30214 13.9669 2.55546C13.9143 2.4935 13.8463 2.42557 13.7105 2.28971C13.5746 2.15385 13.5067 2.08592 13.4447 2.03329C12.6981 1.39906 11.6019 1.39906 10.8552 2.03329C10.7933 2.08591 10.7253 2.15382 10.5895 2.28961L10.5895 2.28969L10.5894 2.28971L9.33123 3.54792C10.0749 4.84212 11.1586 5.91739 12.4705 6.65078ZM7.87657 5.00258L2.86297 10.0162C2.43791 10.4412 2.22538 10.6538 2.08565 10.9149C1.94591 11.176 1.88697 11.4707 1.76908 12.0601L1.37342 14.0384C1.3069 14.371 1.27364 14.5373 1.36825 14.6319C1.46286 14.7266 1.62916 14.6933 1.96177 14.6268L3.94005 14.2311L3.94007 14.2311L3.94009 14.2311C4.52951 14.1132 4.82423 14.0543 5.08532 13.9145C5.34641 13.7748 5.55894 13.5623 5.98398 13.1373L5.984 13.1372L5.98401 13.1372L11.012 8.10922C9.75135 7.31101 8.68226 6.24913 7.87657 5.00258Z"
							fill="currentColor"
							fill-rule="evenodd"
						/>
					</svg>

					<span class="ml-2">Chỉnh sửa lĩnh vực</span>
				</button>
				<button
					:disabled="
						!allSelected.length && !allFoldersSelected?.length
					"
					class="
						button-p
						text-center
						whitespace-nowrap
						w-fit
						px-4
						btn--ghost
					"
					type="button"
					@click="openSideOver('change')"
				>
					<img
						v-if="
							!allSelected.length && !allFoldersSelected?.length
						"
						src="@/assets/images/icons/direction.png"
						alt=""
					/>
					<img
						v-else
						src="@/assets/images/icons/yellow-move.png"
						alt=""
					/>

					<span class="ml-2">Đưa vào thư viện nội bộ</span>
				</button>
			</div>
			<div class="mt-6">
				<div v-if="!isDataLoading">
					<div v-if="rootGoals.length || rootFolders.length">
						<GoalItemsTable
							v-if="rootGoals.length"
							:goals="rootGoals"
							:is-edit="isEdit"
							:skills="skills"
							:show-create-row="isEdit"
							:assistance_levels="assistance_levels"
							@create-goal="createGoal"
							@delete-goal="openDeleteConfirm"
							@updated="updatedGoal"
							@fetch-new="fetchNew"
						/>
						<div v-for="folder in rootFolders" :key="folder.id">
							<GoalFolderItem
								:key="folder"
								:data="folder"
								:is-edit="isEdit"
								:is-search="!!searchQuery"
								:only-folder="true"
								:skills="skills"
								@fetchNew="fetchNew"
								@updated="updatedGoal"
								@create-goal="createGoal"
								@delete-goal="openDeleteConfirm"
								@open-create-modal="openCreateModal"
								:assistance_levels="assistance_levels"
							/>
						</div>
					</div>
					<div v-else-if="!searchQuery && isEdit">
						<GoalItemsTable
							:goals="[]"
							:is-edit="true"
							:skills="skills"
							:show-create-row="true"
							:assistance_levels="assistance_levels"
							@create-goal="createGoal"
							@delete-goal="openDeleteConfirm"
							@updated="updatedGoal"
							@fetch-new="fetchNew"
						/>
					</div>
					<div
						v-else-if="!searchQuery"
						class="
							w-full
							h-full
							flex
							items-center
							justify-center
							flex-col
						"
					>
						<img
							alt=""
							height="250"
							src="@/assets/images/illustrations/not_found.png"
							width="250"
						/>
						<div
							class="text-neutral-400 text-lg text-center"
							style="max-width: 900px"
						>
							Chưa có mục tiêu hoặc thư mục nào trong thư viện
							này.
						</div>
						<div v-if="isAdmin && isLucaEducation" class="mt-8">
							<button
								class="
									button-p
									text-center
									shadow-none
									flex
									items-center
									justify-center
									w-fit
									px-6
									bg-none
									btn--ghost
								"
								type="button"
								@click="isEdit = true"
							>
								Thêm mục tiêu
							</button>
						</div>
					</div>
					<div
						v-else
						class="
							w-full
							h-full
							flex
							items-center
							justify-center
							flex-col
							mt-20
						"
					>
						<img
							alt=""
							height="250"
							src="@/assets/images/illustrations/not_found.png"
							width="250"
						/>
						<div
							class="
								text-neutral-500 text-lg
								max-w-lg
								text-center
							"
						>
							Rất tiếc, chúng tôi không thể tìm thấy kết quả cho
							tìm kiếm của bạn.
						</div>
					</div>
				</div>
				<div v-else class="fixed top-1/2 left-1/2">
					<Loading />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame';
import { $api } from '@/services';
import DaIcon from '@/components/elements/daIcon/DaIcon';
import CreateGoalFolder from '@/views/goalFolders/features/CreateGoalFolder';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import DeleteGoalLibConfirm from '@/views/goalLib/features/deleteGoalLibConfirm';
import DeleteConfirm from '@/views/goalFolders/features/deleteConfirm';
import Loading from '@/components/common/Loading';
import GoalFolderItem from '@/views/goalFolders/features/GoalFolderItem';
import GoalItemsTable from '@/views/goalFolders/features/GoalItemsTable';
import ExitModal from '@/components/elements/exitModal/ExitModal';
import UpdateGoalSkills from '@/views/goalFolders/features/UpdateGoalSkills';
import MoveToLibrary from '@/views/goalReferenceFolders/MoveToLibrary';

export default {
	name: 'GoalReferenceFolders',
	components: {
		MoveToLibrary,
		UpdateGoalSkills,
		ExitModal,
		GoalFolderItem,
		GoalItemsTable,
		Loading,
		DeleteGoalLibConfirm,
		CreateGoalFolder,
		DaIcon,
		DaModalFrame,
		DeleteConfirm,
		Menu,
		MenuItem,
		MenuItems,
		MenuButton,
	},

	data() {
		return {
			isLoading: true,
			modalIsOpen: false,
			goalDeleted: null,
			isEdit: false,
			goal: {
				id: '',
				name: '',
				created_by_staff: {
					name: '',
				},
				last_updated_at: null,
			},
			error: '',
			parent: null,
			inProgress: false,
			skills: [],
			folders: [],
			isDataLoading: true,
			exitModalIsOpen: false,
			errorFolderName: '',
			errorFolderNameInId: '',
			typing: '',
			searchQuery: '',
			sortBy: '',
			sideOverShow: false,
			type: '',
			action: '',
			assistance_levels: []
		};
	},

	created() {
		this.fetchGoalLib();
		this.fetchSkill();
		this.fetchGoalFolders();
		this.fetchAssistanceLevel();
		this.$store.dispatch('clearSelected');
	},

	computed: {
		id() {
			return this.$route?.params?.id || '';
		},

		isAdmin() {
			return this.$store.getters.isAdmin;
		},

		allSelected() {
			return this.$store.getters.goalsSelected;
		},

		allFoldersSelected() {
			return this.$store.getters.foldersSelected;
		},

		rootGoals() {
			return (this.folders || []).filter((item) => item.is_goal);
		},

		rootFolders() {
			return (this.folders || []).filter((item) => !item.is_goal);
		},

		isLucaEducation() {
			return (
				this.$store?.state?.profile?.current_org?.subdomain ===
				'luca_education'
			);
		},
	},

	methods: {
		openSideOver(type) {
			this.type = type;
			this.sideOverShow = true;
		},
		closeSideOver() {
			this.type = '';
			this.sideOverShow = false;
		},
		fetchNew(value) {
			this.sortBy = value;
			this.fetchGoalFolders();
		},
		async fetchSkill() {
			try {
				const {
					data: { data },
				} = await $api.goal.allSkills(this.isAdmin);
				if (data) {
					this.skills = data;
				}
			} catch (e) {
				console.log(e);
			}
		},
		async fetchAssistanceLevel() {
			try {
				const res = await $api.org.staffFetchAssistanceLevel();
				if (res?.data) {
					this.assistance_levels = res?.data?.data;
				}
			} catch (e) {
				console.log(e);
			}
		},
		async fetchGoalFolders() {
			try {
				const {
					data: { data },
				} = await $api.goal.fetchAllGoalFolders(
					this.id,
					{
						query: this.searchQuery,
						sort_by: this.sortBy,
						query_reference_goal: true,
					},
					this.isAdmin
				);
				this.folders = data;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.isDataLoading = false;
			}
		},

		async fetchGoalLib() {
			try {
				const {
					data: { data },
				} = await $api.goal.fetchGoalLibDetail(this.id, true, {
					query_reference_goal_library: true,
				});
				this.goal = data;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		async createGoalFolder(data) {
			this.inProgress = true;
			try {
				await $api.goal.createGoalFolder(
					this.id,
					{
						is_goal: false,
						name: data.name,
						parent_id: this.parent?.id,
						skill_id: '',
					},
					{
						is_reference: true,
					}
				);
				this.closeModal();
				this.isEdit = true;
				await this.fetchGoalFolders();
				this.$store.dispatch('setAlertMessage', {
					message: 'Tạo thư mục thành công',
				});
			} catch (e) {
				if (e?.response?.data?.errors) {
					this.$store.dispatch('setAlertMessage', {
						message:
							e?.response?.data?.errors?.join('<br/>') ||
							'Đã có lỗi xảy ra. Vui lòng thử lại',
						type: 'danger',
					});
				}
				this.error =
					e?.response?.data?.errors_by_field['library_items'];
			} finally {
				this.inProgress = false;
			}
		},

		updatedGoal() {
			this.fetchGoalFolders();
		},

		async createGoal(data) {
			if (!data.name) {
				return;
			}
			try {
				await $api.goal.createGoalFolder(
					this.id,
					{
						is_goal: true,
						name: data.name,
						parent_id: data?.parent_id,
						skill_id: data.skill?.id,
					},
					{
						is_reference: true,
					}
				);
				this.closeModal();
				await this.fetchGoalFolders();
				this.$store.dispatch('setAlertMessage', {
					message: 'Tạo mục tiêu thành công',
				});
				await this.fetchGoalFolders();
			} catch (e) {
				if (
					e?.response?.data?.errors_by_field &&
					e?.response?.data?.errors_by_field['library_items']
				) {
					await this.$store.dispatch('setAlertMessage', {
						message: 'Tên mục tiêu không được trùng.',
						type: 'danger',
					});
				} else {
					await this.$store.dispatch('setAlertMessage', {
						message:
							e?.response?.data?.errors?.join('<br/>') ||
							'Đã có lỗi xảy ra. Vui lòng thử lại',
						type: 'danger',
					});
				}
			}
		},

		openDeleteConfirm(data) {
			this.action = 'deleting';
			this.modalIsOpen = true;
			this.goalDeleted = data;
		},

		async deleteFolderItem({ itemId, isGoal = false }) {
			try {
				await $api.goal.deleteGoalFolder(this.id, itemId, {
					is_reference: true,
				});
				this.closeModal();
				this.$store.dispatch('setAlertMessage', {
					message: isGoal ? 'Đã xoá mục tiêu' : 'Đã xoá thư mục',
				});
				await this.fetchGoalFolders();
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		openCreateModal(data) {
			this.action = 'creating';
			this.modalIsOpen = true;
			this.goalDeleted = null;
			this.parent = data;
		},

		async deleteLib(id) {
			this.inProgress = true;
			try {
				await $api.goal.deleteGoalLibrary(id);
				this.closeModal();
				this.$store.dispatch('setAlertMessage', {
					message: 'Đã xoá thư viện',
				});
				await this.$router.push('/goal-lib');
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},

		openModalDeleted() {
			this.action = 'deleting';
			this.goalDeleted = {
				id: this.id,
				root: true,
			};
			this.modalIsOpen = true;
		},

		closeModal() {
			this.modalIsOpen = false;
			this.goalDeleted = null;
			this.parent = null;
			this.action = '';
		},

		searching() {
			clearInterval(this.typing);
			this.typing = setTimeout(() => {
				this.search();
			}, 500);
		},

		async search() {
			this.isDataLoading = true;
			await this.fetchGoalFolders();
			this.isDataLoading = false;
		},

		refetchData() {
			this.fetchGoalFolders();
			this.closeSideOver();
			this.$store.dispatch('clearSelected');
		},
	},

	beforeUnmount() {
		this.$store.dispatch('clearSelected');
	},
};
</script>
